import React, { useContext } from 'react';
import { GlobalStateContext } from 'store/GlobalStateContext';
import { Alert } from '../Alert/Alert';
import { Confirm } from '../Confirm/Confirm';
import { GlobalSpinner } from '../GlobalSpinner/GlobalSpinner';

export const AlertConfirmSpinnerProvider = () => {
  const [globalState] = useContext(GlobalStateContext);
  const { alert, spinner, confirm } = globalState;
  return (
    <>
      <Alert data={alert} />
      <Confirm {...confirm} />
      {spinner && <GlobalSpinner />}
    </>
  );
};
